import { render, staticRenderFns } from "./SearchResultsModal.html?vue&type=template&id=13535e38&scoped=true&external"
import script from "./SearchResultsModal.js?vue&type=script&lang=js&external"
export * from "./SearchResultsModal.js?vue&type=script&lang=js&external"
import style0 from "./SearchResultsModal.scss?vue&type=style&index=0&id=13535e38&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13535e38",
  null
  
)

export default component.exports